import React, { useEffect, useState } from "react";
import LayoutFrontend from "./inc/layout-frontend";
import { Link } from "react-router-dom";
import { myroutes } from "../routes/webroute";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Pagination from 'react-bootstrap/Pagination';
import CategoriesService from "../services/CategoriesService";
import EditeursService from "../services/EditeursService";
import AuteursService from "../services/AuteursService";
import PublicationsService from "../services/PublicationsService";
import PeriodiquesService from "../services/PeriodiquesService";
import { Image } from "react-bootstrap";
import { app_url } from "../services/http";
import Swal from "sweetalert2";
import { addToCart } from "../app/providers/panierSlice";
import { useDispatch } from "react-redux";


export default function Catalogue() {

  const [categories, setCategories] = useState([]);

  const [selectedCategories, setSelectedCategories] = useState([]);

  const [editeurs, setEditeurs] = useState([]);

  const [selectedEditeurs, setSelectedEditeurs] = useState([]);

  const [auteurs, setAuteurs] = useState([]);

  const [auteur_id, setAuteur_id] = useState('');

  const [editeur_id, setEditeur_id] = useState('');

  const [categorie_id, setCategorie_id] = useState('');


  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 4;

  const [publications, setPublications] = useState([]);

  const [periodiques, setPeriodiques] = useState([]);

  const data = publications;

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const publication = data.slice(indexOfFirstItem, indexOfLastItem);

  const [isbn, setIsbn] = useState("");

  const dispatch = useDispatch();

  //get publications
  const fetchPublications = async () => {
    try {
      const response = await PublicationsService.index();
      setPublications(response.data.publications); // Utilisez response.data.publications au lieu de response.data
      //console.log(response.data.publications)
      // Récupérer les libellés des périodiques à partir des IDs
      const ids = response.data.publications.map(publication => publication.periodique_id);
      const periodiquesResponse = await PeriodiquesService.index(ids);
      setPeriodiques(periodiquesResponse.data.liste_periodiques);
    } catch (error) {
      console.log(error);
    }
  };

  

  useEffect(() => {
    
    //get publications by isbn depuis la base de données
    

    //get categories depuis la base de données
    const fetchCategories = async () => {
      try {
        const response = await CategoriesService.index();
        const data = response.data.categories
        const categoriesArray = Array.isArray(data) ? data : Object.values(data);
        setCategories(categoriesArray);
      } catch (error) {
        console.log(error);
      }
    };

    //get editeurs
    const fetchEditeurs = async () => {
      try {
        const response = await EditeursService.index();
        const data = response.data.liste_editeurs;
        const editeursArray = Array.isArray(data) ? data : Object.values(data);
        setEditeurs(editeursArray);
      } catch (error) {
        console.log(error);
      }
    };

    //get auteurs
    AuteursService.index().then(response => {
      if (Array.isArray(response.data.liste_auteurs)) {
        setAuteurs(response.data.liste_auteurs);
      } else {
        console.error('La réponse ne contient pas un tableau auteurs:', response.data);
      }
    }).catch(error => {
      console.error('Erreur lors de la récupération des auteurs:', error);
    });

    //fetchPublicationsByAuteur 
    const fetchPublicationsByAuteur = async () => {
      try {
        const response = await PublicationsService.getByAuteur(auteur_id);
        const filteredPublications = response.data.publications;
        setPublications(filteredPublications);
        console.log(filteredPublications);
      } catch (error) {
        console.log(error);
      }
    };
    
    if (auteur_id !== '') {
      fetchPublicationsByAuteur();
    }
    
    //fetchPublicationsByEditeur
    const fetchPublicationsByEditeur = async () => {
      try {
        const response = await PublicationsService.getByEditeur(editeur_id);
        setPublications(response.data.publications);
      } catch (error) {
        console.log(error);
      }
    };

    if (editeur_id !== '') {
      fetchPublicationsByEditeur();
    }

    fetchEditeurs();
    fetchCategories();
    fetchPublications();
    fetchPublicationsByAuteur();
  }, [auteur_id, editeur_id]);

  //get categorie selected
  const handleCheckboxChange = (event) => {
    const category = parseInt(event.target.value); //get categorie value
    const isChecked = event.target.checked; //get event checked

    //Verifie si isChecked = true
    if (isChecked) {
      setSelectedCategories([...selectedCategories, category]); //mettre dans la variable temporaire ...selectedCategories la valeur de category
      //console.log(selectedCategories)
      if (selectedCategories.length > 0) {
        filterByCategorie(selectedCategories);
      }
    } else {
      const updatedCategories = selectedCategories.filter((selectedCategory) => selectedCategory !== category); //Supprimer la category de la liste
      setSelectedCategories(updatedCategories);
      //console.log(selectedCategories)
      if (selectedCategories.length > 0) {
        filterByCategorie(selectedCategories);
      }
    }
  };

  const filterByCategorie = async (category) => {
    //Convertir en donnees en formulaire
    const formData = new FormData();

    for (let i = 0; i < category.length; i++) {
      formData.append('categories[]', category[i]);
    }
    // Code pour filtrer les données en fonction de la catégorie sélectionnée
    await PublicationsService.getByCategories(formData).then((response) => {
      setPublications(response.data);
      //console.log(response.data)
    }).catch(error => {
      console.log(error)
    })

    //console.log("Filtrage des données pour la catégorie :", category);
  };

  ////###################### handle Editeur Checkbox change ####################///
  const handleEditeurCheckboxChange = (event) => {
    const editor = parseInt(event.target.value); //get editeur value
    const isChecked = event.target.checked; //get event checked

    //Verifie si isChecked = true
    if (isChecked) {
      setSelectedEditeurs([...selectedEditeurs, editor]); //mettre dans la variable temporaire ...selectedEditeurs la valeur de editor
      if (selectedEditeurs.length > 0) {
        filterByEditeurs(selectedEditeurs);
      }
    } else {
      const updatedEditeurs = selectedEditeurs.filter((selectedEditor) => selectedEditor !== editor); //Supprimer l'editor de la liste
      setSelectedEditeurs(updatedEditeurs);
      if (selectedEditeurs.length > 0) {
        filterByEditeurs(selectedEditeurs);
      }
    }
  };

  // Code pour filtrer les données en fonction des editeurs sélectionnée
  const filterByEditeurs = async (editor) => {
    //Convertir en donnees en formulaire
    const formData = new FormData();

    for (let i = 0; i < editor.length; i++) {
      formData.append('editeurs[]', editor[i]);
    }
    await PublicationsService.getByEditeur(formData).then((response) => {
      setPublications(response.data.publications);
    }).catch(error => {
      console.log(error)
    })
  };
  ////###################### handle Editeur Checkbox change ####################///

  useEffect(() => {
    //Verifier si au moins une categorie est selectionnée
    if (selectedCategories.length > 0) {
      filterByCategorie(selectedCategories);
    } else if (selectedEditeurs.length > 0) {
      //Verifier si au moins un editeur est selectionnée
      filterByEditeurs(selectedEditeurs);
    } else {
      //Si rien n'est cocher afficher toute la liste sans filtre
      fetchPublications();
    }
  }, [selectedCategories, selectedEditeurs]);

  
  const handleSearch = async () => {
    try {
      const response = await PublicationsService.getByIsbn(isbn);
      const publicationsData = response.data.publications;
      setPublications(publicationsData);
  
      if (publicationsData.length > 0) {
        // Afficher une alerte de succès
        Swal.fire({
          icon: "success",
          title: "Un élément correspondant à votre code ISBN a été trouvé",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          background: "green",
          color: "white",
          iconColor: "white",
        });
      } else {
        // Afficher une alerte d'erreur
        Swal.fire({
          icon: "error",
          title: "Aucun élément correspondant à votre code ISBN n'a été trouvé",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          background: "red",
          color: "white",
          iconColor: "white",
        });
      }
  
      // Réinitialiser le champ de recherche
      setIsbn("");
    } catch (error) {
      console.log(error);
    }
  };

  
  const ajouterPanier = async (publication) => {
    try {
      let price = publication.montant_publication; // Valeur par défaut
  
      if (publication.typepublication_id === 2 && publication.periodique_id) {
        // Récupérer les informations du périodique
        const periodique = periodiques.find((periodique) => periodique.id === publication.periodique_id);
  
        if (periodique) {
          price = periodique.montant_periodique; // Utiliser montant_periodique pour typepublication_id = 2
        }
      }
  
      let set_publication = {
        id: publication.id,
        name: publication.titre,
        price: price,
        laune: publication.laune_path,
      };
      let item = { ...set_publication, quantity: 1 };
      dispatch(addToCart(item));
      // Voir le contenu du panier
      //console.log(contentPanier);
    } catch (error) {
      console.log(error);
    }
  };
  

  return (
    <LayoutFrontend>
      {/** Navbar Start */}
      <div className="container-fluid position-relative p-0">
        <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom: "90px" }}>
          <div className="row py-5">
            <div className="col-12 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-4 text-white animated zoomIn">Catalogue</h1>
              <Link className="h5" style={{ color: "goldenrod" }} to={myroutes.homepage}>
                Accueil
              </Link>
              <i className="far fa-circle text-white px-2"></i>
              <Link className="h5 text-white" to={myroutes.catalogue}>
                Catalogue
              </Link>
            </div>
          </div>
        </div>

      </div>
      {/** Navbar End */}

      <div className="section-title text-center position-relative pb-3 mb-5 mx-auto">
        <h5 className="fw-bold text-primary text-uppercase"></h5>
        <h1 className="text-legend mb-3 m-3 ">PUBLICATIONS DISPONIBLES EN VENTE</h1>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-lg-3" style={{ minheight: "20px", color: "red", boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>
            <div className="row">
              <div className="" style={{ minheight: "100px", backgroundColor: "#116BB9" }}>
                <p className="text-light fw-bold fs-6 m-4 text-center">Recherche par code ISBN</p>
                <InputGroup className="mb-3">
                <Form.Control
                  type="text"
                  value={isbn}
                  onChange={(e) => setIsbn(e.target.value)}
                  placeholder="Entrez le code ISBN"
                />
                <Button variant="outline-light" id="button-addon1" onClick={handleSearch}>
                  <i className="bi bi-search"></i>
                </Button>

              </InputGroup>
              </div>
              <p className="text-dark fw-bold fs-5 m-3 mt-5 mx-auto">  Domaines</p>
              <div className="row px-0 mb-4">
                <div className="trait"></div>
              </div>
              <div className="">
                <div className="checklist">
                  {categories.length > 0 && categories.map((categorie, index) => (
                    <div key={index} className="flex align-items-center">
                      <input type="checkbox" value={categorie.id} onChange={handleCheckboxChange} />
                      <label htmlFor="ingredient1" className="mx-2 text-black">{categorie.libelle}</label>
                    </div>
                  ))}
                </div>
              </div>

              <p className="text-dark fw-bold fs-5 m-3 mt-5 mx-auto">  Auteurs</p>

              <div className="col-md-12 col-sm-12">
                <label className="form-label-wrapper mb-4">
                  <select className="form-select" value={auteur_id} onChange={(e) => setAuteur_id(e.target.value)} id="nom_auteur" name="nom_auteur">
                    <option value="">Sélectionnez un auteur</option>
                    {auteurs.map(auteur => (
                      <option key={auteur.id} value={auteur.id}>{auteur.nom_auteur}</option>
                    ))}
                  </select>

                </label>
              </div>

              <p className="text-dark fw-bold fs-5 m-3 mt-5 mx-auto">  Editeurs</p>
              <div className="row px-0 mb-4">
                <div className="trait"></div>
              </div>

              <div className="">
                <div className="checklist">
                  {editeurs.length > 0 && editeurs.map((editeur) => (
                    <div key={editeur.id} className="flex align-items-center">
                      <input type="checkbox" value={editeur.id} onChange={handleEditeurCheckboxChange} />
                      <label className="mx-2 text-black">{editeur.raison_sociale}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-8" style={{ minheight: "20px", color: "green" }}>
            <div className="row">

              <Container style={{ backgroundColor: 'rgb(241, 247, 255)', padding: '40px', border: '1px solid #D9D9D9', borderRadius: '3px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)' }}>

                {publication.map(( item) => (
                  <Row key={item.id} style={{ marginBottom: '30px' }}>
                    <div>
                      <p style={{ borderBottom: '1px dashed black' }}></p>
                    </div>
                    <Col xs={12} md={2} style={{ backgroundColor: 'white', padding: '10px' }}>
                      <a href={`/details_publications/${item.id}`}>
                        <Image alt="Image" style={{ width: '100%', height: 'auto', border: '1px solid gold' }} src={app_url + "/storage/laune/" + item.laune_path} />
                      </a>
                    </Col>

                    <Col xs={12} md={6} style={{ backgroundColor: 'white', padding: '15px' }}>
                      <div>
                        <p className="" style={{ fontWeight: 'bold', fontStyle: 'italic', color: "#116BB9", fontSize: '18px', lineHeight: "1.5rem" }}>{item.titre}</p>
                        <p style={{ color: 'black', fontSize: '16px' }}>
                          {auteurs.find((auteur) => auteur.id === item.auteur_id)?.nom_auteur}
                        </p>
                        <p style={{ color: 'black', fontSize: '16px' }}>
                          {editeurs.find((editeur) => editeur.id === item.editeur_id)?.raison_sociale}
                        </p>
                        <p style={{ color: 'black', fontSize: '16px', fontWeight: "bold" }}>Année: {item.annee_publication}</p>
                        <p style={{ color: 'black', fontSize: '16px', fontWeight: "bold" }}>{item.nbre_page} pages</p>
                      </div>
                    </Col>

                    <Col xs={12} md={4} style={{ backgroundColor: 'white', padding: '10px', display: 'flex', alignItems: 'center' }}>
                      <div>
                        <div className="row">
                          <div className="col-md-8">
                      
                        <Button style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: "100%", marginBottom: "10px" }} variant="warning">
                        {item.typepublication_id === 2 ? 
                          (periodiques.find(p => p.id === item.periodique_id)?.montant_periodique?.toLocaleString() || 'N/A') 
                          : 
                          (item.montant_publication ? parseFloat(item.montant_publication).toLocaleString() : 'N/A')
                        } F CFA
                      </Button>
                          </div>
                          <div className="col-md-4">
                          <button type="button" class="btn btn-outline-warning" data-mdb-ripple-color="dark" onClick={()=>ajouterPanier(item)}><i className="fas fa-shopping-cart"></i></button>
                          </div>
                        </div>
                        <div>
                        <Button href={`/details_publications/${item.id}`} style={{ width: "106%" }} variant="outline-danger">Plus d'informations</Button>
                        </div>
                      </div>

                    </Col>
                  </Row>

                ))}

              </Container>

          <Pagination className="mt-3 justify-content-center">
                <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                <Pagination.Prev onClick={() => setCurrentPage(currentPage - 1)} disabled={currentPage === 1} />

                {Array.from({ length: Math.ceil(data.length / itemsPerPage) }).map((_, index) => (
                  <Pagination.Item
                    key={index}
                    active={index + 1 === currentPage}
                    onClick={() => setCurrentPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}

                <Pagination.Next onClick={() => setCurrentPage(currentPage + 1)} disabled={currentPage === Math.ceil(data.length / itemsPerPage)} />
                <Pagination.Last onClick={() => setCurrentPage(Math.ceil(data.length / itemsPerPage))} disabled={currentPage === Math.ceil(data.length / itemsPerPage)} />
              </Pagination>


            </div>
          </div>
        </div>
      </div>



    </LayoutFrontend>

  )
}